import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Прямоугольник_891"
            data-name="Прямоугольник 891"
            width="19.25"
            height="22"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Tiff" clipPath="url(#clip-path)">
        <path
          id="Контур_828"
          data-name="Контур 828"
          d="M1.371,0H13.058L19.25,6.168V20.625A1.375,1.375,0,0,1,17.871,22H1.371A1.375,1.375,0,0,1,0,20.625V1.375A1.375,1.375,0,0,1,1.371,0Z"
          fill="#299b72"
        />
        <path
          id="Контур_829"
          data-name="Контур 829"
          d="M19.231,6.188H14.438a1.375,1.375,0,0,1-1.375-1.375V.014Z"
          fill="#1c7353"
        />
        <path
          id="Контур_830"
          data-name="Контур 830"
          d="M6.455,14.22h-1.2v3.256H4.29V14.22H3.112v-.744H6.455ZM8,17.476H7.043v-4H8Zm3.3-1.593H9.752v1.593H8.788v-4h2.676v.744H9.752v.92h1.555Z"
          transform="translate(2.337 -2.476)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
